<template lang="html">
  <div class="container">
    <div class="wrapper">
      <div class="header-box">
        <i class="icon-fanhui iconfont icon"  @click="$router.go(-1)"></i>
        <input v-model="selectedProject.project_name" type="text" placeholder="请输入项目名" name="" value="">
      </div>
      <mt-index-list>
        <mt-index-section >
          <mt-cell  v-for="(i,index) in projectList" :title="i" :key="index" :index="index" @click.native="chooseProject(i,index)" ></mt-cell>
        </mt-index-section>
      </mt-index-list>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import axios from 'axios'
  import { IndexList, IndexSection } from 'mint-ui';
  import { Search } from 'mint-ui';

  export default {
    data () {
      return {
        value:'',
        searchProjects: [],
        selectedProject: {
          project_name: '',
        },
        projectList:{},
        routeFrom: ''
      }
    },
    components: {

    },
    watch: {
      $route: {
        handler () {
          this.routeFrom = this.$route.query.from
        },
        immediate: true
      },
      ['selectedProject.project_name'](val) {
        this.$http.getProSearch({project_name:val}).then(res => {
          this.projectList = res.data
        })
      }
    },
    methods: {
      chooseProject(name,index1) {
        this.$router.push({name:'openticket',params:{name:name,index:index1}})
          let data={
           name: name,
            index:index1,
          }
        window.localStorage.setItem( 'choosepro', JSON.stringify(data) )

      },

    },

    mounted () {

      this.projectList=this.$route.params.proList
      console.log( this.projectList)
    },

  }
</script>

<style lang="css" scoped>
  *{
    color: black;
    /*background: #212533;*/
    background: #fff;
  }

  .container, .wrapper {
    width: 100%;
    height: 100%;
  }
  .tagtxt{
    width: 40%;
    /*background: hsla(210, 66%, 54%, .2);*/
    background: #ccc;

    height: 2.5rem;
    border-radius: 6px;
    line-height: 2.5rem;
    text-align: center;
    float: left;
    margin-bottom: 2%;
  }
  .tagtxt:nth-child(odd){
    margin-right: 8%;
    margin-left: 2%;
  }
  .tagtxt:nth-child(even){
    margin-left: 8%;
    margin-right: 2%;
  }
  .hotbox{
    overflow: auto;
  }
  .hotbox h1{
    font-size: 14px;
    color: rgba(255, 255, 255, 0.5);
    padding: 10px;
  }

  .header-box{
    width: 100%;
    height: 1.5rem;
    line-height: 1.5rem;
    /*background: hsla(218, 17%, 31%, .2);*/
    /*background: #ccc;*/
    position: relative;
    border-bottom: 1px solid rgba(66, 75, 93, .5);
  }
  .header-box input{
    width: 86%;
    height: 1rem;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 5%;
    margin: auto;
    border-radius: 2px;
    /*background: rgba(66, 76, 93, .2);*/
    background: #F4F4F4;
    padding-left: 3%;
  }
  .icon-dropdown{
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    font-size: 1.4rem;
    transform: rotate(90deg);
    background: #292d3b;
  }
i_back{
  color:red
}

</style>



// WEBPACK FOOTER //
// src/components/drillPage/ProjectList.vue